import { createFileRoute } from '@tanstack/react-router'
import ConversasPage from '@/pages/conversas/conversas-page'

// Rota index para /dashboard/$dashboardId/conversas/$channelInstanceUuid
// Renderizada quando acessar diretamente /dashboard/$dashboardId/conversas/$channelInstanceUuid
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/conversas/$channelInstanceUuid/',
)({
  component: function ConversasChannelRoute() {
    const { dashboardId, channelInstanceUuid } = Route.useParams()
    return (
      <ConversasPage
        dashboardId={dashboardId}
        channelInstanceUuid={channelInstanceUuid}
      />
    )
  },
})
